var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTotalLikeModel = function SvgIconTotalLikeModel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M8.644 6.012a3.06 3.06 0 0 0-4.393 0 3.245 3.245 0 0 0 0 4.522l5.155 5.253a.833.833 0 0 0 1.19 0l5.153-5.253a3.244 3.244 0 0 0 0-4.522 3.06 3.06 0 0 0-4.393 0l-.76.776a.833.833 0 0 1-1.19 0zm1.19-1.167.166.17.167-.17a4.73 4.73 0 0 1 6.772 0 4.91 4.91 0 0 1 0 6.857l-5.154 5.252a2.5 2.5 0 0 1-3.57 0l-5.153-5.253a4.91 4.91 0 0 1 0-6.856 4.73 4.73 0 0 1 6.772 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconTotalLikeModel;